import { z } from 'zod';
const API_ID_PATTERN = /^\d+$/;
/** Telegram API hash from my.telegram.org — 32 lowercase hex characters. */
const API_HASH_PATTERN = /^[a-f0-9]{32}$/;
export const telegramApiCredentialsInputSchema = z.object({
    apiId: z
        .string()
        .trim()
        .min(1, 'API ID is required')
        .regex(API_ID_PATTERN, 'API ID must contain digits only'),
    apiHash: z
        .string()
        .trim()
        .min(1, 'API Hash is required')
        .regex(API_HASH_PATTERN, 'API Hash must be a 32-character hex string'),
});
//# sourceMappingURL=telegram-api-integration.js.map